import React, { Component } from 'react';
import moment from 'moment-timezone';
import { compose } from 'recompose';
import { translate } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import Tag from '../../components/Tag';
import HorasReservaciones from '../../components/Balance/HorasReservaciones';

class BalanceContainer extends Component {

    didChangeTime = (start_date) => {
        const startDate = moment(start_date, 'YYYY-MM-DD HH:mm:ss');
        return startDate
    }
    render() {
        const balance = this.props.balance
        const { t } = this.props;
        const ruta_imagen = 'https://img.iosoffices.com/img/salas_imagenes/salas/'
        const sum = this.props.new_balance.TotalHrsGrandesDisponibles + this.props.new_balance.TotalHrsChicasDisponibles
        const sum_usa =  this.props.new_balance.hrsGrandesUtilizadas + this.props.new_balance.hrsChicasUtilizadas
        return (
            <section className='balance-container'>
                <span className='h4 iossala'>
                    {t('dashboard.reservations.reservations_hours')}
                </span>
                <div className='contHoras'>
                    <HorasReservaciones
                        tipoDeSala = {t('dashboard.reservations.big_remaining')}
                        horasDisponibles = { this.props.new_balance.TotalHrsGrandesDisponibles || 0 }
                        horasUsadas = { this.props.new_balance.hrsGrandesUtilizadas || 0 }
                    >
                    </HorasReservaciones>
                    <HorasReservaciones
                        tipoDeSala = {t('dashboard.reservations.special_big_remaining')}
                        horasDisponibles = { this.props.new_balance.TotalHrsEspecialesGrandesDisponibles || 0 }
                        horasUsadas = { this.props.new_balance.hrsEspecialesGrandesUtilizadas || 0 }
                    >
                    </HorasReservaciones>
                    <HorasReservaciones
                        tipoDeSala = {t('dashboard.reservations.small_remaining')}
                        horasDisponibles = { this.props.new_balance.TotalHrsChicasDisponibles || 0 }
                        horasUsadas = { this.props.new_balance.hrsChicasUtilizadas || 0 }
                    >
                    </HorasReservaciones>
                    <HorasReservaciones
                        tipoDeSala = {t('dashboard.reservations.special_small_remaining')}
                        horasDisponibles = { this.props.new_balance.TotalHrsEspecialesChicasDisponibles || 0 }
                        horasUsadas = { this.props.new_balance.hrsEspecialesChicasUtilizadas || 0 }
                    >
                    </HorasReservaciones>
                </div>
                <div className="balance_hours">
                    <h4 className="iossala">
                        {t('dashboard.reservations.upcoming_reservations')}
                    </h4>
                {
                    balance.events.length > 0 ? (
                        <div id="carousel-example-generic" className="carousel slide" data-ride="carousel">
                            <div className="carousel-inner" role="listbox">
                                {balance.events.map((event, index) => {
                                    const nombre_imagen = event.nombre_imagen ? event.nombre_imagen : 'muestra.jpg'
                                    const activeClassName = index === 0 ? 'item active' : 'item';
                                    return (
                                        <Link key={event.id} className={activeClassName} to={"/history/" + event.id}>
                                            <div className="card-panel card">
                                                <div className="panel-heading card-panel-heading" style={{ backgroundImage: "url('" + ruta_imagen + nombre_imagen + "')" }}>
                                                </div>
                                                <div className="card-panel-body">
                                                    <div className="panel-body-title">
                                                        <h4 className="ioscentro">{event.centro_name}</h4>
                                                        <h4 className="iossala">{event.name}</h4>
                                                    </div>
                                                    <div className="panel-body-description">
                                                        <div className="panel-description-information">
                                                            <div className="flex-tags flex-tags__big">
                                                                <Tag
                                                                    isBigTag
                                                                    icon='calendar'
                                                                    text={t("venta_linea.reservation_tags.date")}
                                                                    value={moment(event.start, 'YYYY-MM-DD HH:mm:ss').format('ll')}
                                                                />
                                                                <Tag
                                                                    isBigTag
                                                                    alt
                                                                    icon='people-group'
                                                                    text={t("venta_linea.reservation_tags.capacity")}
                                                                    value={`${event.people} personas`}
                                                                />
                                                                <Tag
                                                                    isBigTag
                                                                    icon='clock'
                                                                    text={t("venta_linea.reservation_tags.time")}
                                                                    value={`${moment(event.start, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')} - ${moment(event.finish, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')}`}
                                                                />
                                                                <Tag
                                                                    isBigTag
                                                                    alt
                                                                    icon='user'
                                                                    text={t("venta_linea.reservation_tags.by")}
                                                                    value={event.member_name}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    )}
                                )}
                            </div>
                            <a className="left carousel-control" href="#carousel-example-generic" role="button" data-slide="prev">
                                <span className="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
                                <span className="sr-only">Previous</span>
                            </a>
                            <a className="right carousel-control" href="#carousel-example-generic" role="button" data-slide="next">
                                <span className="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
                                <span className="sr-only">Next</span>
                            </a>
                        </div>
                    ) : (
                        <div className="alert alert-info text-center" role="alert">
                            <h4>{t('dashboard.profile.balance.label_carousel_empty')}</h4>
                            <Link to="/reservations" className="btn btn-primary">
                            {t('dashboard.profile.balance.label_button_carousel_empty')}
                            </Link>
                        </div>
                    )
                }
                </div>
            </section>
        )
    }
}

export default compose(
    translate('common'),
    withRouter
)(BalanceContainer);


// WEBPACK FOOTER //
// ./src/dashboard/mainPage/BalanceContainer.js